import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import moment from 'moment';
import * as echarts from 'echarts';
let default_1 = class default_1 extends Vue {
    dataSeries;
    dataX;
    timeType;
    option;
    charts;
    timeFormatter(dateStr) {
        const date = moment(dateStr);
        if (this.timeType === 'MINUTE') {
            return `${date.format('MM/DD')}\n ${date.format('HH:mm')}`;
        }
        else if (this.timeType === 'HOUR') {
            return `${date.format('MM/DD')}\n ${date.format('HH:mm')}`;
        }
        else if (this.timeType === 'DAY') {
            return `${date.format('yyyy')}\n ${date.format('MM/DD')}`;
        }
        return dateStr;
    }
    onDataXChange(dataX) {
        // @ts-ignore
        this.option.xAxis.data = dataX || [];
    }
    onIntervalChange(val) {
        // @ts-ignore
        // this.option.xAxis.axisLabel.interval = val;
    }
    onDataSeriesChange(dataSeries) {
        this.initDataSeries(dataSeries);
        // @ts-ignore
        this.draw();
    }
    initDataSeries(dataSeries) {
        const [data0] = dataSeries;
        this.option.xAxis.data = this.dataX || [];
        this.option.xAxis.axisLabel.formatter = this.timeFormatter;
        if (data0 instanceof Array) {
            dataSeries.forEach((data, index) => {
                this.option.series[index].data = data || [];
            });
        }
        else if (typeof data0 === 'number' || typeof data0 === 'string') {
            this.option.series[0].data = dataSeries || [];
        }
    }
    mounted() {
        // @ts-ignore
        // this.option.xAxis.data = this.dataX || [];
        // this.option.xAxis.axisLabel.interval = this.interval;
        // @ts-ignore
        this.initDataSeries(this.dataSeries);
        // this.option.xAxis.axisLabel.formatter = this.timeFormatter;
        this.charts = echarts.init(this.$refs['charts']);
        this.initEvents();
        this.draw();
    }
    initEvents() {
        this.charts.on('dataZoom', debounce(this.onDataZoomChange, 100));
    }
    onDataZoomChange(event) {
        const option = this.charts.getOption();
        const { dataZoom = [], xAxis = [] } = option || {};
        const startIndex = dataZoom[0]?.startValue || 0;
        const timeList = xAxis[0]?.data || [];
        const endIndex = dataZoom[0]?.endValue || timeList.length - 1;
        const timeStart = timeList[startIndex];
        const timeEnd = timeList[endIndex];
        if (!timeStart || !timeEnd)
            return;
        this.$emit('on-data-zoom-change', timeStart, timeEnd);
    }
    draw() {
        if (!this.charts)
            return;
        this.charts.clear();
        this.charts.resize();
        //
        if (this.option?.tooltip) {
            this.option.tooltip.className =
                this.option.tooltip?.className ?? 'echarts-tooltip echarts-tooltip-dark';
        }
        this.charts.setOption(this.option, true);
    }
    onLocaleChange(newVal) {
        this.initDataSeries(this.dataSeries);
        this.draw();
    }
    onResize() {
        this.charts && this.charts.resize();
    }
};
__decorate([
    Prop({ default: [] })
], default_1.prototype, "dataSeries", void 0);
__decorate([
    Prop({ default: [] })
], default_1.prototype, "dataX", void 0);
__decorate([
    Prop()
], default_1.prototype, "timeType", void 0);
__decorate([
    Prop()
], default_1.prototype, "option", void 0);
__decorate([
    Watch('dataX')
], default_1.prototype, "onDataXChange", null);
__decorate([
    Watch('interval')
], default_1.prototype, "onIntervalChange", null);
__decorate([
    Watch('dataSeries')
], default_1.prototype, "onDataSeriesChange", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
default_1 = __decorate([
    Component({ name: 'TimelineCharts' })
], default_1);
export default default_1;
